var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.datas,"show-summary":""}},[_c('el-table-column',{attrs:{"label":"年份","prop":"year","width":"200"}}),_c('el-table-column',{attrs:{"label":"学时","prop":"hour"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }